
const jqueryValidation = require('jquery-validation');
require('jquery-validation/dist/additional-methods');
// const IBAN = require('iban');
const IBAN = require('fast-iban');
const dayjs = require('dayjs')
var customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

window.dayjs = dayjs;



function validateDO(numer)
{
  //Check length
  if (numer == null || numer.length != 9)
  return false;

  numer = numer.toUpperCase();
  letterValues = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
  'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
  'U', 'V', 'W', 'X', 'Y', 'Z'];
  function getLetterValue(letter)
  {
  for (j=0; j<letterValues.length; j++)
  if (letter == letterValues[j])
  return j;
  return -1;
  }

  //Check seria
  for (i=0; i<3; i++)     
  if (getLetterValue(numer[i]) < 10)
  return false;
  //Check number
  for (i=3; i<9; i++)
  if (getLetterValue(numer[i]) < 0 || getLetterValue(numer[i]) > 9)
  return false;

  //sprawdz cyfre controlna
  sum = 7 * getLetterValue(numer[0]) +
  3 * getLetterValue(numer[1]) +
  1 * getLetterValue(numer[2]) +
  7 * getLetterValue(numer[4]) +
  3 * getLetterValue(numer[5]) +
  1 * getLetterValue(numer[6]) +
  7 * getLetterValue(numer[7]) +
  3 * getLetterValue(numer[8]);
  sum %= 10;
  if (sum != getLetterValue(numer[3]))
  return false;

  return true;
}
 


jQuery.validator.addMethod('dateFuture', function(value, element, params) {
    var isafter = dayjs(value,'DD/MM/YYYY').isAfter(dayjs(),'day');
    // debugger;
    return this.optional(element) || isafter;
}, 'needs to be later than today');

jQuery.validator.addMethod('dateDaysInFuture', function(value, element, params) {
    var isafter = dayjs(value,'DD/MM/YYYY').isAfter(dayjs().add(params,'days'),'day');
    // debugger;
    return this.optional(element) || isafter;
}, function(params, element){
    return `needs to be later than ${params} from today`
});

jQuery.validator.addMethod('dateTodayAndFuture', function(value, element, params) {
    var isafter = dayjs(value,'DD/MM/YYYY').isAfter(dayjs().subtract(1,'day'),'day');
    // debugger;
    return this.optional(element) || isafter;
}, 'can not be date from past');

jQuery.validator.addMethod('datePast', function(value, element, params) {
    var isafter = dayjs(value,'DD/MM/YYYY').isAfter(dayjs(),'day');
    // debugger;
    return this.optional(element) || isafter;
}, 'needs to be older than today');

// polish letters added to jquery validation
jQuery.validator.addMethod('lettersOnly', function(value, element) {
    return this.optional(element) || /^[a-z A-ZąĄęĘżŻźŹćĆńŃŚśłŁóÓ\-]+$/i.test(value);
}, 'Only letters are allowed');

// polish letters added to jquery validation
jQuery.validator.addMethod('fullName', function(value, element) {
    return this.optional(element) || /^[a-z A-ZąĄęĘżŻźŹćĆńŃŚśłŁóÓ\-]+ [a-z A-ZąĄęĘżŻźŹćĆńŃŚśłŁóÓ\-]+$/i.test(value);
}, 'Enter your full name');

// phone polish validatior
jQuery.validator.addMethod('phonePL', function(phone_number, element) {
    phone_number = phone_number.replace(/\+/g, '');
    return this.optional(element) || phone_number.length === 11;
}, 'Enter valid phone number +48xxxxxxxxx');
jQuery.validator.addMethod('phone', function(phone_number, element) {
    
    return this.optional(element) || phone_number.length > 8;
}, 'Enter valid phone number');

// kod pocztowy
jQuery.validator.addMethod("kodpocztowy", function(value, element) {
  return this.optional(element) || /^\d{2}-\d{3}$/.test(value);
}, "Enter valid postal code");


jQuery.validator.addMethod("pesel", function(value, element) {
    var pesel = value.replace(/[\ \-]/gi, ''); 
    function isPesel(pesel) {
        if (pesel.length != 11) { return false; } else {
            var steps = new Array(1, 3, 7, 9, 1, 3, 7, 9, 1, 3); 
            var sum_nb = 0;
            for (var x = 0; x < 10; x++) { sum_nb += steps[x] * pesel[x];}
                sum_m = 10 - sum_nb % 10;
                if (sum_m == 10) { sum_c = 0; } else { sum_c = sum_m;}
                if (sum_c != pesel[10]) {	return false;}
        }
        return true;
    }	
    return this.optional(element) || isPesel(pesel);
}, "Enter valid PESEL number");

jQuery.validator.addMethod("idNumber", function(value, element) {
    
    return this.optional(element) || validateDO(value);
}, "Enter valid ID number");

// NIP validatior
jQuery.validator.addMethod('nip', function(value, element) {

    function validatenip(nip) {
        var nip_bez_kresek = nip.replace(/-/g,"");
        var reg = /^[0-9]{10}$/;
        if(reg.test(nip_bez_kresek) == false) {
            return false;
        }
        else
        {
            var dig = (""+nip_bez_kresek).split("");
            var kontrola = (6*parseInt(dig[0]) + 5*parseInt(dig[1]) + 7*parseInt(dig[2]) + 2*parseInt(dig[3]) + 3*parseInt(dig[4]) + 4*parseInt(dig[5]) + 5*parseInt(dig[6]) + 6*parseInt(dig[7]) + 7*parseInt(dig[8]))%11;
            if(parseInt(dig[9])==kontrola)
            return true;
            else
            return false;
        }

    }

    function isInArray(value, array) {
      return array.indexOf(value) > -1;
    }

    var isChecksumOK = validatenip(value);
    var disallow = ["1111111111", "2222222222", "3333333333", "4444444444", "5555555555", "6666666666", "7777777777", "8888888888", "9999999999", "0000000000"];
    var isDisallowed = isInArray(value, disallow);

    var response = !isDisallowed && isChecksumOK;

	return this.optional(element) || response;

}, 'Enter valid NIP number');

// NIP validatior
jQuery.validator.addMethod('iban', function(value, element) {
    
  var response = String(value).length == 26;
  console.log({ response});

	return this.optional(element) || response;

}, 'Enter valid account number (26 digits)');

// in bytes
export const MEGABYTE = 1024 * 1024;
export const FIVE_MEGABYTES = 5 * MEGABYTE;

$.validator.addMethod('filesize', function(value, element, param) {
  // param = size (in bytes) 
  // element = element to validate (<input>)
  // value = value of the element (file name)
  return this.optional(element) || (element.files[0].size <= param) 
}, 'You can upload up to 5MB');